import gql from 'graphql-tag'

export default gql`
  fragment BlockCount on BlockList {
    pagination {
      count
    }
  }
`
